import { Injectable } from '@angular/core';

import { tap } from 'rxjs/operators';

import { TiimeOverlayRef, TiimeOverlayService } from 'tiime-material';

import { UploadDocumentOverlayComponent } from './upload-document-overlay.component';
import { UploadDocumentService } from './upload-document.service';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentOverlayService {
  private overlayRef: TiimeOverlayRef;

  constructor(
    private uploadDocumentService: UploadDocumentService,
    private overlayService: TiimeOverlayService
  ) {}

  closeOverlay(): void {
    if (!this.overlayRef) {
      return;
    }
    this.overlayRef.close();
  }

  openOverlayWithFiles(files: FileList): void {
    this.openDocumentUploaderOverlay();
    this.uploadDocumentService.addFilesToQueue(files);
  }

  private openDocumentUploaderOverlay(): void {
    if (this.overlayRef) {
      return;
    }

    this.overlayRef = this.overlayService.open(UploadDocumentOverlayComponent, null, {
      panelClass: 'upload-receipt-overlay-panel',
      minHeight: '0px',
      maxHeight: '275px',
      width: '400px',
      hasBackdrop: false,
      backdropClose: false
    });

    this.overlayRef
      .afterClosed()
      .pipe(tap(() => this.uploadDocumentService.clearQueue()))
      .subscribe(() => (this.overlayRef = undefined));
  }
}
